import { Component } from '@angular/core';
import { Fields } from 'src/app/shared/models/candidateprofile-genmodel';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.scss'],
  standalone: false,
})
export class LabelComponent {
  field: Fields;
  group: UntypedFormGroup;
  constructor() {}

  getControlLabel() {
    return this.group.get(this.field.name).value;
  }
}
